import React from 'react';
import { ClbToast } from '@celebration/design-system/dist/lib/toast';
import { createComponent } from '@lit-labs/react';
import ToastBase from '../toast-base';
import { useToast } from '../../../app/contexts/toast/toast.context';
import IToast from './interfaces/IToast';

const Toast = createComponent({
    react: React,
    elementClass: ClbToast,
    tagName: ClbToast.tagName,
});

function ToastComponent() {
    const { toasts } = useToast();

    return (
        <Toast className="toast-list" data-testid="toast-list">
            {toasts.map((toast: IToast, index: number) => {
                return (
                    <ToastBase
                        // eslint-disable-next-line react/no-array-index-key
                        key={`toast_${index}`}
                        type={toast.type}
                        title={toast.title}
                        description={toast.description}
                        open={toast.open}
                        onClbClickToastClose={() => {
                            toast.open = false;
                        }}
                        data-testid="toast"
                        link={toast.link}
                    />
                );
            })}
        </Toast>
    );
}

export default ToastComponent;
